import { http } from "../ConnectApi/ConnectApi";

export async function SellBRLAController(data: { amount: Number, pixKey: string  }) {
  try {
    const response = await http.post('tftc/sell/brla', data, {
      withCredentials: true
    });

    return response;
  } catch (error: any) {
    console.error('Error during request:', error.response?.data || error.message);
    throw error;
  }
}
